import React, { useEffect, useState } from 'react';

const IdentityCard: React.FC = () => {
  const [isAnimating, setIsAnimating] = useState(true);
  const [isHiddenByHover, setIsHiddenByHover] = useState(false);
  const [isHiddenByScroll, setIsHiddenByScroll] = useState(false);
  const isHidden = isHiddenByHover || isHiddenByScroll;

  useEffect(() => {
    const onScroll = () => setIsHiddenByScroll(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    // Animation duration matches CSS animation (4 seconds)
    const timer = setTimeout(() => {
      setIsAnimating(false);
    }, 4000);

    // Add event listeners for hero card hover and CV page elements
    const selectors = [
      '.hero-card',        // Home page hero card
      '.cv-iframe',        // CV iframe
      '.cv-hero-section',  // CV hero section
      '.cv-section-compact', // CV compact sections
      '.btn-cv-download',  // CV download button
      '.card'              // Publication cards and other content cards
    ];
    
    const handleMouseEnter = () => {
      setIsHiddenByHover(true);
    };
    
    const handleMouseLeave = () => {
      setIsHiddenByHover(false);
    };

    const elements: Element[] = [];
    selectors.forEach(selector => {
      const foundElements = document.querySelectorAll(selector);
      foundElements.forEach(element => {
        elements.push(element);
        element.addEventListener('mouseenter', handleMouseEnter);
        element.addEventListener('mouseleave', handleMouseLeave);
      });
    });

    return () => {
      clearTimeout(timer);
      elements.forEach(element => {
        element.removeEventListener('mouseenter', handleMouseEnter);
        element.removeEventListener('mouseleave', handleMouseLeave);
      });
    };
  }, []);

  return (
    <div className={`identity-card ${isAnimating ? 'identity-card-animating' : 'identity-card-static'} ${isHidden ? 'identity-card-hidden' : ''}`}>
      <div className="identity-card-string"></div>
      <div className="identity-card-inner" style={{
        border: '1px solid black',
        borderRadius: '8px',
        overflow: 'hidden'
      }}>
        <div className="identity-card-header" style={{
          // backgroundImage: 'url(/id-card/assets25.png)', // commented per request
          backgroundColor: '#f5f5f5',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          position: 'relative',
          borderBottom: '1px solid black',
          paddingBottom: '12px',
          minHeight: '48px'
        }}>
          <div className="identity-card-hole"></div>
          {/*
          <span className="identity-card-title" style={{
            color: '#ffffff',
            fontWeight: 'bold',
            backgroundColor: '#000000',
            padding: '4px 12px',
            borderRadius: '4px',
            position: 'relative',
            zIndex: 1
          }}>PRESENTING SOON AT ASSETS 2025</span>
          */}
        </div>
        
        <div className="identity-card-content">
          <div className="identity-card-photo" style={{
            border: '1px solid black',
            borderRadius: '4px',
            overflow: 'hidden'
          }}>
            <img 
              src="/img/about-potrait.jpg" 
              alt="Sanchita Kamath" 
              className="identity-card-image"
            />
          </div>
          
          <div className="identity-card-info">
            <h3 className="identity-card-name">Sanchita Kamath</h3>
            <p className="identity-card-org">Current Affiliation: U of I, Urbana-Champaign</p>
            <div className="identity-card-social-logos">
              <a href="https://www.linkedin.com/in/sanchitakamath" target="_blank" rel="noopener noreferrer" title="LinkedIn">
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/linkedin/linkedin-original.svg" alt="LinkedIn icon - click to visit Sanchita's LinkedIn profile" className="identity-card-social-icon" />
              </a>
              <a href="https://github.com/sk-143381" target="_blank" rel="noopener noreferrer" title="GitHub">
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg" alt="GitHub icon - click to visit Sanchita's GitHub profile" className="identity-card-social-icon" />
              </a>
              <a href="https://orcid.org/0000-0001-6469-0360" target="_blank" rel="noopener noreferrer" title="ORCID">
                <img src="https://upload.wikimedia.org/wikipedia/commons/0/06/ORCID_iD.svg" alt="ORCID icon - click to visit Sanchita's ORCID profile" className="identity-card-social-icon" />
              </a>
              <a href="https://credentials.illinois.edu/9df478e3-d023-4c37-9255-e06055f4a0f8#acc.mCBj8ATb" target="_blank" rel="noopener noreferrer" title="IADP">
                <img src="/logo/iadp.png" alt="Information Accessibility Design and Policy (IADP) credential logo - click to view Sanchita's accessibility certification" className="identity-card-iadp-logo" />
              </a>
            </div>
            <div className="identity-card-details">
              <div className="identity-card-detail">
                <span className="identity-card-label">Email:</span>
                <a href="mailto:ssk11@illinois.edu" className="identity-card-link">
                  ssk11@illinois.edu
                </a>
              </div>
              
              <div className="identity-card-detail">
                <span className="identity-card-label">Scholar:</span>
                <a 
                  href="https://scholar.google.com/citations?hl=en&user=sanchitakamath" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="identity-card-link"
                >
                  Google Scholar
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IdentityCard;
